var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "record-grid container-fluid" }, [
    _c(
      "div",
      { staticClass: "row no-gutters" },
      _vm._l(_vm.mapsList, function (item) {
        return _c("record-item", {
          key: item.identifier,
          attrs: {
            record: item,
            service: _vm.service,
            authkeyParamNames: _vm.authkeyParamNames,
            catalogURL: _vm.catalogURL,
            catalogType: _vm.catalogType,
            map: _vm.map,
            crs: _vm.crs,
            hideThumbnail: _vm.hideThumbnail,
            hideExpand: _vm.hideExpand,
            hideIdentifier: _vm.hideIdentifier,
            layerBaseConfig: _vm.layerBaseConfig,
            showGetCapLinks: _vm.showGetCapLinks,
            source: _vm.source,
            zoomToLayer: _vm.zoomToLayer,
            layers: _vm.layers,
            showTemplate: _vm.showTemplate,
            defaultFormat: _vm.defaultFormat,
            formatOptions: _vm.formatOptions,
            infoFormatOptions: _vm.infoFormatOptions,
          },
          on: { onLayerAdd: _vm.onLayerAdd, onError: _vm.onError },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }